import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DigestDashboard from './pages/DigestDashboard';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Digest dashboard is a standalone page (no sidebar, no admin chrome)
const path = window.location.pathname;
if (path.startsWith('/digest')) {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/digest" element={<DigestDashboard />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

reportWebVitals();
